import { Component, OnInit } from '@angular/core';
import { Apollo, QueryRef } from 'apollo-angular';
import {
  EventsGQL,
  EventsQuery,
  EventsQueryVariables,
  UserGql
} from '@app/graphql/generated';
import { Router } from '@angular/router';
import { Filter } from '@app/shared/filter/filter.component';
import { CurrentUser, UserService } from '@app/user/user.service';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { config } from '@app/app.config';
import { EventService } from '@app/event/event.service';
import { MatSnackBar } from '@angular/material/snack-bar';


const eventFilters = {
  MINE: 'mine',
  PUBLIC: 'public',
  ALL: 'all'
};

interface ResponseCode {
  statusCode: number
}

@Component({
  selector: 'app-list-events',
  templateUrl: './list-events.component.html',
  styleUrls: ['./list-events.component.scss']
})
export class ListEventsComponent implements OnInit {
  columnsToDisplay = ['image', 'title', 'dictationTime', 'download', 'delete'];

  events = [];
  loading = false;
  _search;
  gridView = {
    data: [],
    total: 0
  };
  page = 0;
  perPage = 15;
  queryRef: QueryRef<EventsQuery, EventsQueryVariables>;
  apiURL = config.httpURL;
  filters$: Observable<Filter[]>;
  selectedFilter = eventFilters.MINE;
  currentUser: Observable<CurrentUser>;
  canLaunchEvent: any;

  constructor(
    private apollo: Apollo,
    private eventsGql: EventsGQL,
    private eventService: EventService,
    private router: Router,
    private userService: UserService,
    private snackBar: MatSnackBar
  ) {
  }

  ngOnInit() {
    this.currentUser = this.userService.currentUser();
    this.queryRef = this.eventsGql.watch();
    this.setFilters();
  }

  setFilters() {
    this.filters$ = this.currentUser.pipe(
      map((user: CurrentUser) => {
        // @ts-ignore
        if(user.permissions.filter(perm => perm.name.includes('engine').length > 0)){
          this.canLaunchEvent = true;
        }
        const filters = [
          { label: 'My Events', value: eventFilters.MINE },
          { label: 'Public', value: eventFilters.PUBLIC }
        ];

        const adminFilters = [
          ...filters,
          { label: 'All', value: eventFilters.ALL }
        ];

        const guestFilters = [];
        // @ts-ignore
        if (user.username === 'guest') {
          this.selectedFilter = eventFilters.PUBLIC;
          return guestFilters;
        }
        return user.isAdmin ? adminFilters : filters;
      })
    );
  }

  search(search: string) {

    this._search = search;
  }

  cellClick(row, $event) {
    const eventId = row.shortId;
    if ($event?.target?.innerHTML === 'Download Audio') {
      this.eventService.downloadAudio(row.shortId, row.title);
    } else if ($event?.target?.innerHTML === 'Delete Audio') {
      this.eventService.deleteAudio(row.shortId).subscribe((resp: ResponseCode) => {
        if (resp.statusCode === 204) {
          this.snackBar.open('Audio deleted successfully!', 'Dismiss', { duration: 3500 });
        } else {
          this.snackBar.open('Error deleting audio', 'Dismiss', { duration: 3500 });
        }
      });   
    } else {
      this.router.navigateByUrl(`/events/${eventId}`);
    }
  }

  filterChange(filter: string) {
    this.selectedFilter = filter;
  }
}
